<template>
  <div>
    <v-data-table
      :items="logList"
      :headers="documentAgreementLogsHeaders"
      :loading="$loading.isLoading('getLogs')"
      :items-per-page="-1">
      <template #[`item.user`]="{ item }">
        {{ getPersonName(item.user, { initials: true }) }}
      </template>
      <template #[`item.status`]="{ item }">
        <div class="font-weight-bold">
          <!-- -->
          <span v-if="item.newStatusId === 1"> Чорновик </span>
          <!-- -->
          <span
            v-else-if="
              [1, 3].includes(item.oldStatusId) &&
              item.newStatusId === 3 &&
              item.isApproved
            ">
            <span>
              Завізовано
              <span class="text-success text-no-wrap">
                (Погодив документ)
              </span>
            </span>
          </span>
          <span
            v-else-if="
              [1, 3].includes(item.oldStatusId) &&
              item.newStatusId === 3 &&
              !item.isApproved
            ">
            <span> Додано </span>
          </span>
          <!-- -->
          <span v-else-if="item.oldStatusId === 3 && item.newStatusId === 2">
            <span>
              Доопрацювання документа
              <span class="text-grey-darken-1">{{ item.text }}</span>
            </span>
          </span>
          <!-- -->
          <span v-else-if="item.oldStatusId === 2 && item.newStatusId === 3">
            <span>
              Доопрацьовано
              <span class="text-grey-darken-1">
                {{ item.text }}
              </span>
            </span>
          </span>
          <!-- -->
          <span v-else-if="item.newStatusId === 4" class="text-success">
            Погоджено всіми
          </span>
        </div>
      </template>
      <template #bottom></template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import { PropType, shallowRef } from 'vue'
import { Dialog } from '@/dialog'
import { documentAgreementLogs } from '@/requests/documentAgreement'
import { handleAsync } from 'best-modules/plugins'
import { getPersonName } from 'best-modules/utils'
import { documentAgreementLogsHeaders } from '@/utils/tableHeaders'

export default {
  name: 'DocumentAgreementHistory',
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  data() {
    return { documentAgreementLogsHeaders }
  },
  methods: { getPersonName },
  setup(props) {
    const logList = shallowRef<any[]>([])
    const getLogs = () => {
      return handleAsync('getLogs', () => {
        return documentAgreementLogs(
          props.dialog.dialogData.documentAgreementId
        ).then(res => {
          logList.value = res
        })
      })
    }

    getLogs()

    return { logList }
  },
}
</script>
